import Image from 'next/image'
import { useState } from 'react'

import classes from './ProductFullStaticBleedHero.module.scss'
import ResponsiveComponent from '@/components/ResponsiveComponent'

import SupportingLocalImage from '@/svgs/WildSource.png'

const ProductFullStaticBleedHero = (fullBleedHero) => {
  const [startVideo, setStartVideo] = useState(false)

  let {
    title,
    heroStyle,
    smallerText,
    textColor,
    imageBrightness,
    alt,
    youtubeVideoId,
    topMargin,
    bottomMargin,
    fixedImage,
  } = fullBleedHero

  function cropImageUrl(image) {
    const { asset, hotspot, crop } = image || {};

    if (!asset?.metadata?.dimensions || !hotspot) {
      return asset?.url;
    }

    const { height: h, width: w } = asset.metadata.dimensions;
    const cropLeft = parseInt(crop.left * w);
    const cropTop = parseInt(crop.top * h);
    const hotspotWidth = parseInt(hotspot.width * w);
    const hotspotHeight = parseInt(hotspot.height * h);

    return urlFor(image)
        .rect(cropLeft, cropTop, hotspotWidth, hotspotHeight)
        .fit('max')
        .auto('format')
        .url();
  }

  const imageInlineStyles = {
    filter: `brightness(${imageBrightness ? imageBrightness : 75}%)`,
  }

  const mobileImageInlineStyles = {
    filter: `brightness(${imageBrightness ? imageBrightness : 75}%)`,
  }

  return (

    <div
      className={`${classes['hero']} ${classes['hero--smaller-text']} ${classes['hero--center']}`}
    >
      <div className={`${classes['hero__text']}`}>
        <div className={classes['hero__text-inner']}>
          <h1
              className={`${classes['hero__header']}_${classes[textColor]} ${classes[`${heroStyle === 'hero--bottom' ? 'heading--catch' : ''}`]}`}
            >
            Supporting Local Communities
          </h1>
        </div>
      </div>
      <div className={classes['hero__main-wrap']}>
        <ResponsiveComponent
          desktopBreakpoint={'sm'}
          mobile={
            SupportingLocalImage && (
              <div
                className={`${classes['hero__wrap']} ${
                  fixedImage ? classes['hero__wrap--mbl'] : ''
                }`}
              >
                <Image
                  className={classes.mbl__img}
                  src={SupportingLocalImage.src}
                  fill
                  objectFit="cover"
                  alt={alt || title || 'Supporting Local Communities'}
                />
              </div>
            )
          }
        />
      </div>
    </div>
  )
}

export default ProductFullStaticBleedHero
